// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QrcodeOutlinedSvg from "@fishx/icons-svg/es/asn/QrcodeOutlined";
import FishxIcon from '../components/FishxIcon';

var QrcodeOutlined = function QrcodeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: QrcodeOutlinedSvg
  }));
};

QrcodeOutlined.displayName = 'QrcodeOutlined';
export default React.forwardRef(QrcodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/QrcodeOutlined.js
// module id = 3943
// module chunks = 0